import { Component, OnInit } from '@angular/core';
import {Store} from '@ngrx/store';
import {Observable} from 'rxjs';
import * as fromApp from '../../store/app.reducers';
import * as fromCompare from '../store/compare.reducers';
import * as fromProfile from '../../profile/store/profile.reducers';


@Component({
    selector: 'app-compare-result',
    templateUrl: './compare-result.component.html',
    styleUrls: ['./compare-result.component.scss'],
    standalone: false
})
export class CompareResultComponent implements OnInit {

  compareState: Observable<fromCompare.State>;
  profileState: Observable<fromProfile.State>;

  constructor(
    private store: Store<fromApp.AppState>
  ) { }

  ngOnInit() {
    this.compareState = this.store.select('compare');
    this.profileState = this.store.select('profile');
  }

}
